import { FormFieldRoot } from "./form-field";
import { FormFieldControl } from "./parts/control";
import { FormFieldErrorMessage } from "./parts/view-error";
import { FormFieldHelp } from "./parts/view-help";
import { FormFieldLabel } from "./parts/view-label";

export { useFormFieldControlProps } from "./form-field.context";
export { REQUIRED_MARK, REQUIRED_MESSAGE } from "./messages";
export type * from "./types-form-field";

/** Campo de formulário composable (`FormField.Root/Label/Control/Help/Error`): liga label, ajuda e erro ao controle por id e `aria-*`. */
export const FormField = {
  Root: FormFieldRoot,
  Label: FormFieldLabel,
  Control: FormFieldControl,
  Help: FormFieldHelp,
  Error: FormFieldErrorMessage,
};
